import axios from "@/plugins/axios";

let url = "/api/v1/me/likes";

export default {
    getLikes(data){
        return axios.get(url, data).then(result => result.data);
    },
    getLike(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    postLike(data){
        return axios.post(url, data).then(result => result.data);
    },
    putLike(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteLike(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
